import BASE_URL from "../../shared/base-url"

export const SALE_ENDPOINT = {
  detail: `${BASE_URL}/sales/get-sale`,
  list: `${BASE_URL}/sales/get-sales`,
  getOwnersOfSale: `${BASE_URL}/owners/get-owners`,
  archive: `${BASE_URL}/sales/archive-sale`,
  delete: `${BASE_URL}/sales/delete-sale`,
  toggleStatus: `${BASE_URL}/sales/activate-or-block-sale`,
  restore: `${BASE_URL}/sales/restore-sale`,
  archivedSales: `${BASE_URL}/sales/get-archived-sales`,
  archivedSale: `${BASE_URL}/sales/get-archived-sale`,
  create: `${BASE_URL}/sales/create-sale`,
  update: `${BASE_URL}/sales/update-sale`,
  updateProfile: `${BASE_URL}/sales/update-sale-profile-image/`,

  export: `${BASE_URL}/sales/export-sales`,
  import: `${BASE_URL}/sales/import-sales`,
  removeFile: `${BASE_URL}/sales/remove-image`,
}
